'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' });

var Check = function Check(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Check = (0, _pure2.default)(Check);
Check.muiName = 'SvgIcon';

exports.default = Check;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Check.js
// module id = 2243
// module chunks = 0